/*
 * ==============================================================================
 *
 * Copyright (c) 2023. Koninklijke Philips Electronics N.V.
 *
 * All rights are reserved. Reproduction in whole or in part is prohibited without the prior written consent of the copyright holder.
 *
 * ==============================================================================
 */

import React, { useContext, useEffect, useState } from "react";
import { updateItem } from "../Esign.common";
import { LayoutContext } from "../../components/layout";
import fetchHelper from "../../services/fetchHelper";
import pdfContext from "../pdfContext";
import { Dashboard2Context } from "../dashboard2";

export const PopupInput = ({
  isChecked,
  onChangeMessage,
  isShowForm,
  setIsShowForm,
  item,
  reportStateMentId,
  pdfPage,
}) => {
  const { fetchI } = useContext(Dashboard2Context);
  const { headerDetails: userInfo } = useContext(LayoutContext);
  const { headerDetails, updateHeaderDetails } = useContext(LayoutContext);
  const [message, setMessage] = useState("");
  const [oldMessage, setOldMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [isInit, setIsInit] = useState(false);
  const [pageDropdown, setPageDropdown] = useState(false);
  const [pageNumber, setPageNumber] = useState(0);
  const [notEditable, setNotEditable] = useState(true);
  const { offSet, numberOfPages } = useContext(pdfContext);

  useEffect(() => {
    setIsError(false);
    setIsInit(true);
  }, [isShowForm]);

  useEffect(() => {
    const noteIndex = (userInfo.reportStatements || []).map((item) => item.cstId).indexOf(item.id);
    setTimeout(() => {
      const note = noteIndex >= 0 ? (userInfo.reportStatements[noteIndex] || {}).note || "" : "";
      setIsInit(false);
      setMessage(note);
      setOldMessage(note);
      onChangeMessage(note);
    }, 400);
  }, []);

  useEffect(() => {
    setIsInit(false);
    setTimeout(() => {
      setMessage("");
      onChangeMessage("");
    }, 100);
  }, [isChecked]);

  const updateMessage = async () => {
    setIsError(false);
    setIsLoading(true);
    try {
      if (isChecked && isInit) {
        const response = await updateItem({ message, reportStateMentId });
        if (response.ok) {
          await fetchI(userInfo.id);
          setIsShowForm(false);
        } else {
          setIsError(true);
        }
      }
      setOldMessage(message);
      if (onChangeMessage) {
        onChangeMessage(message);
      }
    } catch (err) {
      setIsError(true);
      setIsInit(false);
      setTimeout(() => {
        setMessage(oldMessage);
      }, 250);
    } finally {
      setIsLoading(false);
    }
  };

  const updateContextPageNumber = (id, data) => {
    updateHeaderDetails({
      ...headerDetails,
      reportStatements: headerDetails.reportStatements.map((elem) => {
        {
          if (elem.cstId === id) {
            return {
              ...elem,
              pdfLink: data,
            };
          }
          return elem;
        }
      }),
    });
  };

  const savePageNumber = async (data) => {
    setIsError(false);
    setIsLoading(true);
    const interrogationId = headerDetails.id;
    const cst_id = item.id;
    const pdfPageNumber = parseInt(data);
    try {
      await fetchHelper.put(
        `/patientmanagement/rest/reportstatements/${interrogationId}/${cst_id}/pdfLink`,
        pdfPageNumber
      );
      await fetchI(userInfo.id);
      updateContextPageNumber(item.id, pdfPageNumber);
    } catch (error) {
      setIsError(true);
      setIsInit(false);
    }
    setPageDropdown(false);
    setIsShowForm(false);
    setNotEditable(true);
    setIsLoading(false);
  };

  let options = [];
  for (let i = offSet + 1; i <= numberOfPages; i++) {
    if (pdfPage + offSet !== i) options.push(i);
  }

  if (!isChecked) return null;
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-end",
        flex: 1,
      }}
    >
      {isShowForm ? (
        <div
          style={{
            display: "flex",
            flex: 1,
            marginLeft: 50,
            marginTop: 5,
            padding: 5,
            backgroundColor: "#eee",
            alignItems: "center",
            borderRadius: 2,
          }}
        >
          <div className="edit-options">
            {!pageDropdown ? (
              <textarea
                value={message}
                onChange={(e) => setMessage(e.target.value.replace("\n", ""))}
                rows={2}
                className="text-dialog-box"
                style={{
                  borderColor: isError ? "#f00" : undefined,
                  minHeight: "100%",
                  display: "flex",
                  flex: 1,
                  marginRight: 6,
                  height: "100%",
                  resize: "none",
                }}
                disabled={isLoading}
                id="notes-textBox"
              />
            ) : (
              <select
                onChange={(e) => setPageNumber(e.target.value)}
                style={{
                  borderColor: isError ? "#f00" : undefined,
                }}
                disabled={pdfPage > 0 ? notEditable : false}
              >
                {pdfPage > 0 ? <option value={pdfPage}>{pdfPage + offSet}</option> : null}
                <option value={0} id="pdf-number-text">
                  Select or Enter Page Number
                </option>
                {options &&
                  options.map((item) => (
                    <option key={item} value={item - offSet}>
                      {item}
                    </option>
                  ))}
              </select>
            )}
          </div>
          <div style={{ display: "flex", flexDirection: "column" }}>
            <button
              className="btn btn-sm btn-primary btn-cancel btn-x"
              style={{
                marginRight: 3,
                height: 30,
                width: 30,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                backgroundColor: "#008c98",
                borderColor: "#008c98",
              }}
              onClick={(e) => {
                e.preventDefault();
                pageDropdown ? savePageNumber(pageNumber) : updateMessage();
              }}
              id="save-button"
            >
              {isLoading ? (
                <div
                  id="results-loading-icon"
                  className="saving-white-ico icon-64"
                  style={{ width: 15, height: 15 }}
                />
              ) : (
                <div
                  className="check-flat-ico icon-64"
                  style={{
                    marginRight: 0,
                    marginTop: -3,
                    width: 16,
                    height: 16,
                  }}
                />
              )}
            </button>
            <button
              className="btn btn-sm btn-urgent btn-submit btn-x"
              style={{
                height: 30,
                width: 30,
                marginTop: 6,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
              onClick={(e) => {
                e.preventDefault();
                setIsShowForm(false);
                setPageDropdown(false);
                setMessage(oldMessage);
                setNotEditable(true);
              }}
              id="close-button"
            >
              <div
                className="close-flat-ico icon-64"
                style={{ marginRight: 0, marginTop: -1, width: 22, height: 22 }}
              />
            </button>
            <button
              className="btn btn-x btn-yellow"
              style={{
                height: 30,
                width: 30,
                marginTop: 6,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
              disabled={pdfPage === 0 || !pageDropdown ? true : false}
              onClick={(e) => {
                e.preventDefault();
                setNotEditable(false);
              }}
              id="yellow-pencil-btn"
            >
              <div
                className="icon-64 pencil-white-icon"
                style={{ marginRight: 0, marginTop: -1, width: 22, height: 22 }}
              />
            </button>
            <button
              className="btn btn-x btn-success"
              aria-label="link"
              style={{
                height: 30,
                width: 30,
                marginTop: 6,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
              onClick={(e) => {
                e.preventDefault();
                setPageDropdown((pageDropdown) => !pageDropdown);
              }}
              id="pdf-link-btn"
            >
              <div
                className="icon-64 link-ico"
                style={{ marginRight: 0, marginTop: -1, width: 22, height: 22 }}
              />
            </button>
          </div>
        </div>
      ) : (
        <>
          {message ? (
            <div
              style={{
                padding: 10,
                backgroundColor: "rgba(225,225,225,.25)",
                borderRadius: 3,
                color: "#555",
                display: "flex",
                flex: 1,
                marginLeft: 50,
                marginRight: 3,
              }}
            >
              <div style={{ marginTop: -5 }}>
                {message.split("\n").map((item, i) => {
                  return <div key={`mmmm-${i}`}>{item}</div>;
                })}
              </div>
            </div>
          ) : null}
        </>
      )}
    </div>
  );
};
